import { render, staticRenderFns } from "./TreasureMarkerWidget.vue?vue&type=template&id=3d5dc9b2&scoped=true"
import script from "./TreasureMarkerWidget.vue?vue&type=script&lang=js"
export * from "./TreasureMarkerWidget.vue?vue&type=script&lang=js"
import style0 from "./TreasureMarkerWidget.vue?vue&type=style&index=0&id=3d5dc9b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5dc9b2",
  null
  
)

export default component.exports